export enum SessionServiceEventType {
	SESSION_SERVICE_READY = 'SessionServiceReady',
	SESSION_CREATED = 'SessionCreated',
	SESSION_DESTROYED = 'SessionDestroyed',
}
